export default __webpack_public_path__ + "static/media/MooniverseDistributionChart.6def3fe7.png";